export class UpdatePublicApiToken {
  static readonly type = '[Api Token] Update';

  constructor(public payload: string) {}
}
